import * as React from 'react';
import { Checkbox as TPACheckbox } from 'wix-ui-tpa/Checkbox';
import { CheckboxProps } from '../../../../types/AdaptedComponents';
import { UILibrary } from '../../../../types/UILibrary';

export const Checkbox: React.FC<CheckboxProps> = ({ children, ...props }) => {
  return (
    <TPACheckbox
      data-ui-lib={'tpa' as UILibrary}
      label={children}
      onChange={props.onChange}
      checked={props.checked}
      data-hook={props.dataHook}
      error={props.error}
      aria-error={props.error}
    />
  );
};
Checkbox.displayName = 'Checkbox';
